import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { logoutUser } from '../../redux/slices'

const ANALYTICS_LOGOUT_URL = '/analytics/logout'

export const LogoutPage: React.FC = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    const fromGrafana =
      new URLSearchParams(window.location.search).get('from') === 'grafana'
    const goToLogin = () => navigate('/ui2/login', { replace: true })
    const analyticsLogoutExists = () =>
      fetch(ANALYTICS_LOGOUT_URL, { credentials: 'same-origin' })
        .then((response) => response.ok)
        .catch(() => false)

    const p = dispatch<any>(logoutUser())
    p.finally(async () => {
      if (fromGrafana || !(await analyticsLogoutExists())) {
        goToLogin()
      } else {
        window.location.replace(ANALYTICS_LOGOUT_URL)
      }
    })
  }, [dispatch, navigate])

  return <h2>Logging out...</h2>
}
